import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useFlexibleFinanceFilters } from '../../hooks/use-abtest.hook'
import {
    DetailsPadding,
    StyledSearchListing,
    StyledSearchListingAdvert,
    StyledSearchListingAdvertColumn,
} from './search-listing.styles'

export const SkeletonSearchListing = ({ index }: { index: number }) => {
    const isFlexibleFinance = useFlexibleFinanceFilters()
    return (
        <StyledSearchListing>
            <StyledSearchListingAdvert as="div" data-testid={`skeleton-advertCard-${index}`}>
                <div>
                    <Skeleton
                        style={{
                            width: '100%',
                            height: '220px',
                        }}
                    />

                    <StyledSearchListingAdvertColumn $isFlexibleFinance={isFlexibleFinance}>
                        <Skeleton
                            style={{
                                width: '50%',
                                height: '22px',
                                marginBottom: '4px',
                                marginTop: '18px',
                                marginLeft: '8px',
                            }}
                        />
                        <DetailsPadding>
                            <Skeleton style={{ width: '80%', height: '18px', marginBottom: '8px' }} />
                            <Skeleton style={{ width: '30%', height: '24px', marginBottom: '24px' }} />
                            <Skeleton
                                style={{
                                    width: '30%',
                                    height: '26px',
                                    marginBottom: '8px',
                                    marginTop: '8px',
                                }}
                            />
                            <Skeleton style={{ width: '30%', height: '12px', marginBottom: '16px' }} />
                        </DetailsPadding>
                    </StyledSearchListingAdvertColumn>
                </div>
            </StyledSearchListingAdvert>
        </StyledSearchListing>
    )
}
